import type { JSX } from "react";
import { useState } from "react";
import { login } from "../../lib/auth";
import { BrandLogo } from "../BrandLogo";

/**
 * Login screen (#49). Shown when the server has AUTH_ENABLED and no token is
 * stored. Accounts are admin-created (no self-registration), so this is
 * login-only. On success the JWT is stored and the app loads.
 */
export function Login({ onSuccess }: { onSuccess: () => void }): JSX.Element {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    const r = await login(username.trim(), password);
    setBusy(false);
    if (r.ok) onSuccess();
    else setError(r.reason);
  };

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={(e) => void submit(e)}>
        <BrandLogo />
        <h1 className="login-title">登录小环</h1>
        <p className="login-sub">请输入管理员分配的账号</p>
        <label className="login-field">
          <span>用户名</span>
          <input
            type="text"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
          />
        </label>
        <label className="login-field">
          <span>密码</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {error !== null && <div className="login-error">{error}</div>}
        <button className="login-btn" type="submit" disabled={busy || username.length === 0}>
          {busy ? "登录中…" : "登录"}
        </button>
      </form>
    </div>
  );
}
